import MainLoyout from '@/loyout/MainLoyout.vue'
import config from '@/utils/config'
const routes = [
  // {
  //   path: '/home',
  //   name: 'home',
  //   component: MainLoyout,
  //   meta: {
  //     title: '首页',
  //     icon: 'home',
  //     code: config.menuCode.SY
  //   },
  //   children: [
  //     {
  //       path: 'workbench',
  //       name: 'Workbench',
  //       meta: {
  //         title: '工作台',
  //         code: config.menuCode.GZT,
  //         doc: '#首页'
  //       },
  //       component: () => import('@/views/home/Index')
  //     }
  //   ]
  // },
  // {
  //   path: '/order',
  //   name: 'order',
  //   component: MainLoyout,
  //   meta: {
  //     title: '订单管理',
  //     icon: 'order',
  //     code: config.menuCode.DDGL
  //   },
  //   children: [
  //     {
  //       path: 'OrderSearch',
  //       name: 'OrderSearch',
  //       meta: {
  //         title: '订单查询',
  //         code: config.menuCode.DDCX,
  //         doc: '#订单查询'
  //       },
  //       component: () => import('@/views/order/OrderList')
  //     },
  //     {
  //       path: 'Track',
  //       name: 'Track',
  //       meta: {
  //         title: '轨迹查询',
  //         code: config.menuCode.GJCX,
  //         doc: '#轨迹查询'
  //       },
  //       component: () => import('@/views/order/Track')
  //     },
  //     {
  //       path: 'FeeSearch',
  //       name: 'FeeSearch',
  //       meta: {
  //         title: '预估费用查询',
  //         code: config.menuCode.YGFYCX,
  //         doc: '#预估费用查询'
  //       },
  //       component: () => import('@/views/order/FeeSearch')
  //     },
  //     {
  //       path: 'FeeTrial',
  //       name: 'FeeTrial',
  //       meta: {
  //         title: '费用试算',
  //         code: config.menuCode.FYSS,
  //         doc: '#费用试算'
  //       },
  //       component: () => import('@/views/order/FeeTrial')
  //     },
  //     {
  //       path: 'Scan',
  //       name: 'Scan',
  //       meta: {
  //         title: '扫码换单',
  //         code: config.menuCode.SMHD,
  //         doc: '#扫码换单'
  //       },
  //       component: () => import('@/views/order/Scan')
  //     },
  //     {
  //       path: 'CardInquiry',
  //       name: 'CardInquiry',
  //       meta: {
  //         title: '卡派询价',
  //         code: config.menuCode.KPXJ,
  //         doc: '#卡派询价'
  //       },
  //       component: () => import('@/views/order/CardInquiry')
  //     },
  //     {
  //       path: 'OpenClaim',
  //       name: 'OpenClaim',
  //       meta: {
  //         title: '开查索赔',
  //         code: config.menuCode.KCSP,
  //         doc: '#开查索赔'
  //       },
  //       component: () => import('@/views/order/OpenClaim')
  //     }
  //   ]
  // },
  {
    path: '/billManage',
    name: 'billManage',
    component: MainLoyout,
    meta: {
      title: '提单管理',
      icon: 'bill',
      code: config.menuCode.TDGL
    },
    children: [
      {
        path: 'createdBill',
        name: 'createdBill',
        meta: {
          title: '创建提单',
          code: config.menuCode.CJTD,
          doc: '#createdBill'
        },
        component: () => import('@/views/bill/CreatedBill')
      },
      {
        path: 'ISF',
        name: 'ISF',
        meta: {
          title: 'ISF',
          code: config.menuCode.ISF,
          doc: '#isf'
        },
        component: () => import('@/views/bill/ISF')
      },
      {
        path: 'AirBill',
        name: 'AirBill',
        meta: {
          title: '空运提单',
          code: config.menuCode.KYTD,
          doc: '#空运提单'
        },
        component: () => import('@/views/bill/Air')
      },
      {
        path: 'ShipBill',
        name: 'ShipBill',
        meta: {
          title: '海运提单',
          code: config.menuCode.HYTD,
          doc: '#海运提单'
        },
        component: () => import('@/views/bill/Ship')
      },
      // {
      //   path: 'TruckList',
      //   name: 'TruckList',
      //   meta: {
      //     title: '卡派列表',
      //     code: config.menuCode.KPLB,
      //     doc: '#卡派列表'
      //   },
      //   component: () => import('@/views/bill/TruckList')
      // },
      {
        path: 'DirectDeliveryList',
        name: 'DirectDeliveryList',
        meta: {
          title: '直送列表',
          code: config.menuCode.ZSLB,
          doc: '#直送列表'
        },
        component: () => import('@/views/bill/DirectDeliveryList')
      },
      {
        path: 'CheckList',
        name: 'CheckList',
        meta: {
          title: '查验列表',
          code: config.menuCode.CYLB,
          doc: '#查验列表'
        },
        component: () => import('@/views/bill/CheckList')
      }
      // {
      //   path: 'SetBill',
      //   name: 'SetBill',
      //   meta: {
      //     title: '提单设置',
      //     code: config.menuCode.TDSZ,
      //     doc: '#提单设置'
      //   },
      //   component: () => import('@/views/bill/SetBill')
      // }
    ]
  },
  {
    path: '/otherBusiness',
    name: 'OtherBusiness',
    component: MainLoyout,
    meta: {
      title: '其它业务',
      icon: 'other',
      code: config.menuCode.QTYW
    },
    children: [
      {
        path: 'OtherBusiness',
        name: 'OtherBusiness',
        meta: {
          title: '其他业务',
          code: config.menuCode.QTYW,
          doc: '#其他业务'
        },
        component: () => import('@/views/other/Index.vue')
      }]
  },
  {
    path: '/documentationManage',
    name: 'documentationManage',
    component: MainLoyout,
    meta: {
      title: '单证管理',
      icon: 'detail',
      code: config.menuCode.DZGL
    },
    children: [
      {
        path: 'invoiceManagement',
        name: 'invoiceManagement',
        meta: {
          title: '发票管理',
          code: config.menuCode.INVOICE,
          doc: '#invoiceManagement'
        },
        component: () => import('@/views/controlOverInvoices/invoiceManagement')
      },
      {
        path: 'form7501',
        name: 'form7501',
        meta: {
          title: '7501',
          code: config.menuCode.TAXM,
          doc: '#form7501'
        },
        component: () => import('@/views/documentation/form7501')
      },
    {
        path: 'ando',
        name: 'ando',
        meta: {
          title: 'AN/DO',
          code: config.menuCode.ANDO,
          doc: '#ando'
        },
        component: () => import('@/views/andorecord/ando')
      }]
    },
  {
    path: '/company',
    name: 'company',
    component: MainLoyout,
    meta: {
      title: '客户管理',
      icon: 'company',
      code: config.menuCode.KHGL
    },
    children: [
      {
        path: '',
        name: 'Company',
        meta: {
          title: '客户管理',
          code: config.menuCode.KHGL,
          doc: '#客户管理'
        },
        component: () => import('@/views/company/Company')
      }
    ]
  },
  {
    path: '/supply',
    name: 'supply',
    component: MainLoyout,
    meta: {
      title: '供应商管理',
      icon: 'supply',
      code: config.menuCode.GYSGL
    },
    children: [
      {
        path: '',
        name: 'Supply',
        meta: {
          title: '供应商管理',
          code: config.menuCode.GYSGL,
          doc: '#供应商管理'
        },
        component: () => import('@/views/supply/Supply')
      }
    ]
  },
  {
    path: '/importer',
    name: 'importer',
    component: MainLoyout,
    meta: {
      title: '进口商管理',
      icon: 'work',
      code: config.menuCode.JKSGL
    },
    children: [
      {
        path: '',
        name: 'Importer',
        meta: {
          title: '进口商',
          code: config.menuCode.JKSGL,
          doc: '#进口商'
        },
        component: () => import('@/views/Importer/index.vue')
      }]
  },
  {
    path: '/const',
    name: 'const',
    component: MainLoyout,
    meta: {
      title: '财务管理',
      icon: 'const',
      code: config.menuCode.CWGL
    },
    children: [
      {
        path: 'BillWnquiry',
        name: 'BillWnquiry',
        meta: {
          title: '账单查询',
          code: config.menuCode.ZDCX,
          doc: '#账单查询'
        },
        component: () => import('@/views/const/BillWnquiry')
      },
      // {
      //   path: 'ClaimPayment',
      //   name: 'ClaimPayment',
      //   meta: {
      //     title: '申付',
      //     code: config.menuCode.SF,
      //     doc: '#申付'
      //   },
      //   component: () => import('@/views/const/ClaimPayment')
      // },
      {
        path: 'CopeWith',
        name: 'CopeWith',
        meta: {
          title: '应付管理',
          code: config.menuCode.YFGL,
          doc: '#应付管理'
        },
        component: () => import('@/views/const/CopeWith')
      },
      {
        path: 'Receivables',
        name: 'Receivables',
        meta: {
          title: '应收管理',
          code: config.menuCode.YSGL,
          doc: '#应收管理'
        },
        component: () => import('@/views/const/Receivables')
      },
      // {
      //   path: 'DispatchReconciliation',
      //   name: 'DispatchReconciliation',
      //   meta: {
      //     title: '派送对账',
      //     code: config.menuCode.PSDZ,
      //     doc: '#派送对账'
      //   },
      //   component: () => import('@/views/const/DispatchReconciliation')
      // },
      {
        path: 'WaterBill',
        name: 'WaterBill',
        meta: {
          title: '充值水单',
          code: config.menuCode.CZSD,
          doc: '#充值水单'
        },
        component: () => import('@/views/const/WaterBill')
      },
      {
        path: 'FeeQuery',
        name: 'FeeQuery',
        meta: {
          title: '费用查询',
          code: config.menuCode.FYCX,
          doc: '#费用查询'
        },
        component: () => import('@/views/const/FeeQuery')
      },
      {
        path: 'Verification',
        name: 'Verification',
        meta: {
          title: '核销',
          code: config.menuCode.HX,
          doc: '#核销'
        },
        component: () => import('@/views/const/Verification')
      },
      {
        path: 'AccountCustom',
        name: 'AccountCustom',
        meta: {
          title: '客户账户管理',
          code: config.menuCode.KHZHGL,
          doc: '#客户账户管理'
        },
        component: () => import('@/views/const/AccountCustom')
      },
      {
        path: 'AccountsReceivable',
        name: 'AccountsReceivable',
        meta: {
          title: '收款账户管理',
          code: config.menuCode.SKZHGL,
          doc: '#收款账户管理'
        },
        component: () => import('@/views/const/AccountsReceivable')
      },
      {
        path: 'FeeCode',
        name: 'FeeCode',
        meta: {
          title: '费用代码管理',
          code: config.menuCode.FYDMGL,
          doc: '#费用代码管理'
        },
        component: () => import('@/views/const/FeeCode')
      }
    ]
  },
  // {
  //   path: '/workList',
  //   name: 'workList',
  //   component: MainLoyout,
  //   meta: {
  //     title: '工单',
  //     icon: 'work',
  //     code: config.menuCode.GD
  //   },
  //   children: [
  //     {
  //       path: '',
  //       name: 'WorkList',
  //       meta: {
  //         title: '工单',
  //         code: config.menuCode.GD,
  //         doc: '#工单'
  //       },
  //       component: () => import('@/views/workBill/Index.vue')
  //     }]
  // },
  {
    path: '/statisticalAnalysis',
    name: 'statisticalAnalysis',
    component: MainLoyout,
    meta: {
      title: '统计分析',
      icon: 'statistics',
      code: config.menuCode.TJFX
    },
    children: [
      {
        path: 'OperatingStatement',
        name: 'OperatingStatement',
        meta: {
          title: '运营报表',
          code: config.menuCode.YYBB,
          doc: '#运营报表'
        },
        component: () => import('@/views/statistics/OperatingStatement.vue')
      },
      {
        path: 'GrossProfit',
        name: 'GrossProfit',
        meta: {
          title: '毛利统计',
          code: config.menuCode.MLTJ,
          doc: '#毛利统计'
        },
        component: () => import('@/views/statistics/GrossProfit')
      }
    ]
  },
  {
    path: '/system',
    name: 'system',
    component: MainLoyout,
    meta: {
      title: '系统设置',
      icon: 'system',
      code: config.menuCode.XTSZ
    },
    children: [
      {
        path: 'UserOpt',
        name: 'UserOpt',
        meta: {
          title: '用户管理',
          code: config.menuCode.YHGL,
          doc: '#用户管理'
        },
        component: () => import('@/views/system/UserInfo')
      },
      {
        path: 'BaseData',
        name: 'BaseData',
        meta: {
          title: '基础资料',
          code: config.menuCode.JCZL,
          doc: '#基础资料'
        },
        component: () => import('@/views/system/BaseData')
      },
      {
        path: 'UserRole',
        name: 'UserRole',
        meta: {
          title: '角色权限',
          code: config.menuCode.JSQX,
          doc: '#角色权限'
        },
        component: () => import('@/views/system/UserRole')
      },
      // {
      //   path: 'ReviewUser',
      //   name: 'ReviewUser',
      //   meta: {
      //     title: '审核用户',
      //     code: config.menuCode.SHYH,
      //     doc: '#审核用户'
      //   },
      //   component: () => import('@/views/system/ReviewUser')
      // },
      {
        path: 'Rate',
        name: 'Rate',
        meta: {
          title: '汇率设置',
          code: config.menuCode.HLSZ,
          doc: '#汇率设置'
        },
        component: () => import('@/views/system/Rate')
      },
      // {
      //   path: 'WorkBill',
      //   name: 'WorkBill',
      //   meta: {
      //     title: '工单设置',
      //     code: config.menuCode.GDSZ,
      //     doc: '#工单设置'
      //   },
      //   component: () => import('@/views/system/WorkBill')
      // },
      // {
      //   path: 'BillSetting',
      //   name: 'BillSetting',
      //   meta: {
      //     title: '制单设置',
      //     code: config.menuCode.ZDSZ,
      //     doc: '#制单设置'
      //   },
      //   component: () => import('@/views/system/BillSetting')
      // },
      {
        meta: {
          title: '税率库',
          code: config.menuCode.SLK,
          doc: '#税率库'
        },
        path: 'Tax',
        name: 'TaxRate',
        component: () => import('@/views/system/TaxRate.vue')
      },
      {
        meta: {
          title: '产品库',
          code: config.menuCode.CPK,
          doc: '#产品库'
        },
        path: 'Product',
        name: 'Product',
        component: () => import('@/views/system/Product.vue')
      },
      {
        meta: {
          title: '清关咨询',
          code: config.menuCode.QGZX,
          doc: '#清关咨询'
        },
        path: 'ClearanceConsultation',
        name: 'ClearanceConsultation',
        component: () => import('@/views/system/ClearanceConsultation.vue')
      }
      // {
      //   meta: {
      //     title: '预报管理',
      //     code: config.menuCode.YBGL,
      //     doc: '#预报管理'
      //   },
      //   path: 'ForecastManagement',
      //   name: 'ForecastManagement',
      //   component: () => import('@/views/system/ForecastManagement.vue')
      // }
      // {
      //   meta: {
      //     title: '版本公告',
      //     code: config.menuCode.BBGG,
      //     doc: '#版本公告'
      //   },
      //   path: 'Version',
      //   name: 'Version',
      //   component: () => import('@/views/system/Version.vue')
      // }
    ]
  },
  {
    path: '/forecastManagement',
    name: 'forecastManagement',
    component: MainLoyout,
    meta: {
          title: '预报管理',
          code: config.menuCode.YBGL,
         icon: 'work',
          doc: '#预报管理'
    },
    children: [
      {
        path: '',
        name: 'ForecastManagement',
        meta: {
          title: '预报管理',
          code: config.menuCode.YBGL,
          doc: '#预报管理'
        },
        component: () => import('@/views/system/ForecastManagement.vue')
      }
    ]
  },
  // {
  //   path: '/entry',
  //   name: 'entry',
  //   component: MainLoyout,
  //   meta: {
  //         title: 'Entry',
  //         code: config.menuCode.ENTRY,
  //        icon: 'work',
  //         doc: '#Entry'
  //   },
  //   children: [
  //     {
  //       path: '',
  //       name: 'Entry',
  //       meta: {
  //         title: 'Entry',
  //         code: config.menuCode.ENTRY,
  //         doc: '#Entry'
  //       },
  //       component: () => import('@/views/entry/index.vue')
  //     }
  //   ]
  // },
  {
    path: '/emailCenter',
    name: 'emailCenter',
    component: MainLoyout,
    redirect: 'emailSetting',
    meta: {
        title: '邮件中心',
        code: config.menuCode.YJZX,
        icon: 'work',
        doc: '#emailCenter'
    },
    children: [
      {
        path: 'emailSetting',
        name: 'emailSetting',
        meta: {
          title: '邮件设置',
          code: config.menuCode.YJSZ,
          doc: '#邮件设置'
        },
        component: () => import('@/views/email/emailSetting.vue')
      },
      {
        path: 'emailDetail',
        name: 'emailDetail',
        meta: {
          title: '邮件中心',
          code: config.menuCode.YJZX,
          doc: '#emailDetail',
          hidden: true
        },
        component: () => import('@/views/email/emailDetail.vue')
      }
    ]
  },
  {
    path: '/pdf',
    name: 'pdf',
    component: () => import('@/views/PDF'),
    meta: {
      title: 'PDF',
      icon: 'system',
      code: config.menuCode.PDF
    }
  }
]
export default routes
